import React from "react";
// import { Navigate } from "react-router-dom";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { Loader } from "../icons";

const ProtectedRoute = ({ component }) => {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => (
      <div className="flex flex-1 h-full justify-center items-center">
        <Loader height={64} width={64} />
      </div>
    ),
  });

  return <Component />;
};

export default ProtectedRoute;
